import enumeraciones from '@/../static/js/enumeraciones'
import comun from '@/../static/js/comun'
import api from '@/../static/js/api'
import router from '@/../src/router/index'
import axios from 'axios'

let state = {
  SIPSIC_Catalogos_003Psicologos: [],
  SIPSIC_Catalogos_009Areas: [],
  SIPSIC_Catalogos_010TiposPlantillas: [],
  SIPSIC_Catalogos_004EstatusDeDictamen: [],
  SIPSIC_Catalogos_006EstatusCita: [],
  SIPSIC_Catalogos_012TemasEvaluaciones: [],
  SIPSIC_Catalogos_013SalasLudicas: []
}

let getters = {
  Get_SIPSIC_Catalogos_003Psicologo: state => {
    return state.SIPSIC_Catalogos_003Psicologos;
  },
  Get_SIPSIC_Catalogos_009Area: state => {
    return state.SIPSIC_Catalogos_009Areas;
  },
  Get_SIPSIC_Catalogos_010TiposPlantillas: state => {
    return state.SIPSIC_Catalogos_010TiposPlantillas;
  },
  Get_SIPSIC_Catalogos_004EstatusDeDictamen: state => {
    return state.SIPSIC_Catalogos_004EstatusDeDictamen;
  },
  Get_SIPSIC_Catalogos_006EstatusCita: state => {
    return state.SIPSIC_Catalogos_006EstatusCita;
  },
  Get_SIPSIC_Catalogos_012TemaEvaluacion: state => {
    return state.SIPSIC_Catalogos_012TemasEvaluaciones;
  },
  Get_SIPSIC_Catalogos_013SalaLudica: state => {
    return state.SIPSIC_Catalogos_013SalasLudicas;
  }
}

let mutations = {
  M_SIPSIC_Catalogos_003Psicologo(state, data) {
    state.SIPSIC_Catalogos_003Psicologos[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_009Area(state, data) {
    state.SIPSIC_Catalogos_009Areas[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_010TipoPlantilla(state, data) {
    state.SIPSIC_Catalogos_010TiposPlantillas[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_004EstatusDeDictamen(state, data) {
    state.SIPSIC_Catalogos_004EstatusDeDictamen[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_006EstatusCita(state, data) {
    state.SIPSIC_Catalogos_006EstatusCita[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_012TemaEvaluacion(state, data) {
    state.SIPSIC_Catalogos_012TemasEvaluaciones[data.llave] = data.valor;
  },
  M_SIPSIC_Catalogos_013SalaLudica(state, data) {
    state.SIPSIC_Catalogos_013SalasLudicas[data.llave] = data.valor;
  }
}

let actions = {
  A_SIPSIC_Catalogo_Establecer003Psicologo: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_003Psicologo', data);
  },
  A_SIPSIC_Catalogo_Establecer009Area: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_009Area', data);
  },
  A_SIPSIC_Catalogo_Establecer010TipoPlantilla: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_010TipoPlantilla', data);
  },
  A_SIPSIC_Catalogo_Establecer004EstatusDeDictamen: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_004EstatusDeDictamen', data);
  },
  A_SIPSIC_Catalogo_Establecer006EstatusCita: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_006EstatusCita', data);
  },
  A_SIPSIC_Catalogo_Establecer012TemaEvaluacion: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_012TemaEvaluacion', data);
  },
  A_SIPSIC_Catalogo_Establecer013SalaLudica: ({ commit }, data) => {
    commit('M_SIPSIC_Catalogos_013SalaLudica', data);
  }
}

const SIPSIC = {
  Getters: getters,
  State: state,
  Mutations: mutations,
  Actions: actions
}
export default SIPSIC;



// WEBPACK FOOTER //
// ./src/store/SIPSIC.js